export enum ArtworkSelectionStep {
  SizeSelection = "sizeSelection",
  ArtworkOptions = "artworkOptions",
}
